import MinidokaData from "../../../../src/components/minidoka-data.js";
import * as React from 'react';
export default {
  MinidokaData,
  React
};